const Navbar = () => (
  <nav className="bg-blue-600 text-white p-4">
    <div className="container mx-auto flex justify-between items-center">
      <h1 className="text-xl font-bold">React 19 Typescript Boilerplate</h1>
    </div>
  </nav>
);

export default Navbar;
